import React from "react";
import { Download, MonitorPlay } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function RequestATechnicalBrief() {
  return <section id="request-a-technical-brief" className="dark bg-background text-foreground py-16 px-4 md:py-24">
      <div className="max-w-5xl mx-auto">
        <div className="bg-primary text-primary-foreground py-10 px-6 md:px-12 rounded-2xl flex flex-col items-center text-center gap-8 shadow-2xl">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-serif tracking-tight max-w-3xl">Download our 2026 Capability Statement</h2>
          
          <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
            <Button variant="secondary" size="lg" asChild className="w-full sm:w-auto text-base font-semibold">
              <Link to="/InsightsPage">
                <Download className="mr-2 size-5" />
                PDF Download
              </Link>
            </Button>
            
            <Button variant="outline" size="lg" asChild className="w-full sm:w-auto text-base font-semibold bg-transparent border-2 border-primary-foreground text-primary-foreground hover:bg-primary-foreground hover:text-primary transition-colors">
              <Link to="/ContactPage">
                <MonitorPlay className="mr-2 size-5" />
                Request Presentation
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}